/* WaterFun phone buy bar (product page redesign, approved 2026-09-29).
 *
 * Markup: the [data-wf-buybar] element at the end of
 * sections/main-product.liquid. On phones it slides up once the page's own
 * product form has scrolled above the screen, and hides again when the
 * shopper scrolls back to it.
 *
 * It never adds to the cart itself: the button presses the page's real
 * "add" button, so variants, quantity, errors and the cart notification
 * all stay stock Dawn. Dawn re-renders the price and the buy buttons when
 * the shopper picks another option, so the bar re-reads them (price text,
 * button label, sold-out/disabled state) whenever that area changes.
 */
(function () {
  'use strict';
  if (window.wfBuybarInit) return;
  window.wfBuybarInit = true;

  var phone = window.matchMedia('(max-width: 749px)');

  function init(bar) {
    var id = bar.getAttribute('data-section');
    var form = document.getElementById('product-form-' + id);
    var info = document.getElementById('ProductInfo-' + id);
    if (!form || !info) return;

    var priceOut = bar.querySelector('[data-wf-buybar-price]');
    var btn = bar.querySelector('[data-wf-buybar-add]');

    /* Re-query every time: Dawn swaps these elements on variant change. */
    function mainButton() {
      var f = document.getElementById('product-form-' + id);
      return f ? f.querySelector('[name="add"]') : null;
    }

    function sync() {
      var price = info.querySelector('#price-' + id + ' .price');
      var text = '';
      if (price) {
        var el = price.classList.contains('price--on-sale')
          ? price.querySelector('.price__sale .price-item--last')
          : price.querySelector('.price__regular .price-item--regular');
        text = el ? el.textContent.trim() : '';
      }
      if (priceOut.textContent !== text) priceOut.textContent = text;

      var main = mainButton();
      if (main) {
        var label = main.querySelector('span');
        var labelText = (label ? label.textContent : main.textContent).trim();
        if (labelText && btn.textContent !== labelText) btn.textContent = labelText;
        /* Guarded write: assigning .disabled = true to an already-disabled
           button still queues a mutation record (see the cart bar fix,
           2026-09-30). The bar sits outside the observed area here, but a
           write only on real change keeps this safe if that ever moves. */
        if (btn.disabled !== main.disabled) btn.disabled = main.disabled;
      }
    }

    sync();
    new MutationObserver(sync).observe(info, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled', 'class'] });

    /* Show only on phones, and only after the form has scrolled ABOVE the
       screen (not while it is still further down the page). */
    var io = new IntersectionObserver(function (entries) {
      var e = entries[0];
      var show = phone.matches && !e.isIntersecting && e.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', show);
      document.body.classList.toggle('wf-buybar-on', show);
    });
    io.observe(form);

    btn.addEventListener('click', function () {
      var main = mainButton();
      if (main && !main.disabled) main.click();
    });

    bar.hidden = false;
  }

  function start() {
    document.querySelectorAll('[data-wf-buybar]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
